import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/services/api'

export const useMessagesStore = defineStore('messages', () => {
    const messages = ref([])
    const loading = ref(false)
    const sending = ref(false)
    const error = ref(null)

    async function fetchMessages(conversationId, page = 1, limit = 500) {
        loading.value = true
        error.value = null
        try {
            const { data } = await api.get(`/api/conversations/${conversationId}/messages`, {
                params: { page, limit }
            })

            // Backend pode retornar { success: true, data: [...] } ou { messages: [...] }
            if (data && data.data && Array.isArray(data.data)) {
                messages.value = data.data
            } else if (data && data.messages && Array.isArray(data.messages)) {
                messages.value = data.messages
            } else if (Array.isArray(data)) {
                messages.value = data
            } else {
                console.warn('API de mensagens retornou formato inesperado:', data)
                messages.value = []
            }

            return data
        } catch (err) {
            error.value = err.message
            console.error('Error fetching messages:', err)
            messages.value = [] // Garantir array vazio em erro
            throw err
        } finally {
            loading.value = false
        }
    }

    async function sendMessage(payload) {
        sending.value = true
        error.value = null

        // Optimistic update
        const tempMessage = {
            id: `temp-${Date.now()}`,
            conversation_id: payload.conversation_id,
            content: payload.content,
            direction: 'outbound',
            status: 'pending',
            created_at: new Date().toISOString(),
            _temp: true
        }
        messages.value.push(tempMessage)

        try {
            const { data } = await api.post('/api/messages/send', payload)

            // Replace temp message with real one
            const index = messages.value.findIndex(m => m._temp)
            if (index >= 0) {
                messages.value[index] = data.message || data
            }

            return data
        } catch (err) {
            error.value = err.message

            // Remove temp message on error
            const index = messages.value.findIndex(m => m._temp)
            if (index >= 0) {
                messages.value.splice(index, 1)
            }

            console.error('Error sending message:', err)
            throw err
        } finally {
            sending.value = false
        }
    }

    function addMessage(message) {
        const exists = messages.value.find(m => m.id === message.id)
        if (!exists) {
            messages.value.push(message)
        }
    }

    function clearMessages() {
        messages.value = []
    }

    return {
        messages,
        loading,
        sending,
        error,
        fetchMessages,
        sendMessage,
        addMessage,
        clearMessages
    }
})
